export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('DELETE_TIERS_LINKED_TO_SOCIETE_CANNOT_BE_DELETED') !== -1) {
        messages.push({
          message: 'detailClient.popupDeleteTiers.errors.tiersLinkedToSocieteCannotBeDeleted',
        });
      }
      if (message.indexOf('DELETE_TIERS_LINKED_TO_USER_CONNOT_BE_DELETED') !== -1) {
        messages.push({
          message: 'detailClient.popupDeleteTiers.errors.tiersLinkedToUserCannotBeDeleted',
        });
      }
      if (message.indexOf('DELETE_TIERS_IF_ONE_CONTACT_LINKED_TO_USER_CANNOT_BE_DELETED') !== -1) {
        messages.push({
          message: 'detailClient.popupDeleteTiers.errors.ifOneContactLinkedToUserCannotBeDeleted',
        });
      }
      if (message.indexOf('DELETE_TIERS_TIERS_USED_ON_ANOTHER_ENTITY') !== -1) {
        messages.push({
          message: 'detailClient.popupDeleteTiers.errors.tiersUsedOnAnotherEntity',
        });
      }
    }
  });
}
